import Vue from 'vue'
import { mapState } from 'vuex'
import rolebleMixin from '@/mixins/rolebleMixin'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [rolebleMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
      userId: (state: RootState) => state.user?.id,
    }),
    isOwner() {
      return this.application?.customer.id === this.userId || this.vacancy.customer_id === this.userId
    },
    isEmployer() {
      return this.isCustomer && this.isOwner
    },
    isWorker() {
      return this.isFreelancer && this.application.freelancer.id === this.userId
    },
  },
})
